<template>
  <div class="col-xs-12 col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      masked="true"
      v-validate="{ required: required, min: 14 }"
      v-mask="['(##) ####-####', '(##) #####-####']"
      />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'new'
  },
  inject: ['$validator'],
  name: 'c-protocolo-telefone',
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  methods: {
    normalize(telefone) {
      if (telefone) {
        let telefoneClear = telefone.replace(/[^\d]/g, '');

        if (telefoneClear.length === 10) {
          telefone = telefoneClear.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }

        if (telefoneClear.length === 11) {
          telefone = telefoneClear.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
      }

      return telefone;
    }
  },
  watch: {
    value(value) {
      this.$emit('input', this.normalize(value));
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Telefone.vue